import React from "react";
import {inject, observer} from "mobx-react";
import {useTranslation} from "react-i18next";
//local
import WaitSaveButton from "../WaitSaveButton";
import {RichEditor} from "components/RichEditor";
import {TitleIcon} from "components/TitleIcon";
import {Preloader} from "components/Preloader";
import {IconDocumentList} from "components/icons";
import {rfpStatuses} from "constants/buyer.consts";
import {templatesType} from "components/RichEditor";

const RequestEdit = inject("store")(
  observer(({store: {buyer}}) => {
    const {currentRequest, loading} = buyer;
    const {t} = useTranslation();

    const isDraft = currentRequest.status === rfpStatuses.DRAFT;

    const handleChange = (data) => buyer.updateCurrentRequestInfo({description: data});

    return (
      <div className={`request-edit-block${isDraft ? " pt-4" : ""}`}>
        {loading && <Preloader addClass="preloader250" />}
        {!loading && (
          <React.Fragment>
            <WaitSaveButton />
            <TitleIcon
              title={t("DESCRIPTION")}
              addClass="ml-4 mt-4"
              icon={<IconDocumentList />}
              tooltip="CREATE_RFP_DESCRIPTION_TOOLTIP"
            />
            <RichEditor
              key={currentRequest?.id}
              initialValue={currentRequest?.description}
              placeholder="RFP_DESCRIPTION"
              templatesType={templatesType.RFT}
              showTemplateButtons
              showExtendedToolbarButtons
              onChange={handleChange}
            />
          </React.Fragment>
        )}
      </div>
    );
  })
);

export default RequestEdit;
